import React, { PropsWithChildren } from 'react';
import { Modal } from 'react-bootstrap';

import Icon from 'components/DesignSystem/Icon';

import './index.scss';

interface BottomSheetProps {
  open: boolean;
  dismiss: () => void;
  title?: React.ReactNode;
  className?: string;
}

export default function BottomSheet({
  open,
  dismiss,
  title = '',
  className = '',
  children,
}: PropsWithChildren<BottomSheetProps>) {
  return (
    <Modal
      show={open}
      onHide={dismiss}
      className={`bottom-sheet ${className}`.trim()}
      dialogClassName="bottom-sheet-dialog"
      contentClassName="bottom-sheet-content"
    >
      <div className="bottom-sheet-handle" aria-hidden="true" />
      <div className="bottom-sheet-header">
        {title ? <div className="bottom-sheet-title">{title}</div> : <span />}
        <button
          type="button"
          className="bottom-sheet-close"
          aria-label="Fechar"
          onClick={dismiss}
        >
          <Icon iconType="close" color="currentColor" />
        </button>
      </div>
      <div className="bottom-sheet-body">{children}</div>
    </Modal>
  );
}
